import { Registry } from "scantling-common";
import type { Phase } from "./types";

export const phaseRegistry = new Registry<Phase>();

export function getPhases(): Phase[] {
  return phaseRegistry.getAll().sort((a, b) => a.order - b.order);
}
